// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"RY-z","subtitle":"SY-z","wrapper":"TY-z","leftArrow":"UY-z","rightArrow":"VY-z"};